import React, { useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { GLOBAL_CONSTANTS, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { nullUndefinedEmptyCheck, validateInput } from '../../utils/helper';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import { useForgotPasswordMutation } from '../../service/apiSlices/authService';
import { toast } from 'react-toastify';
import approval_icon from "../../assets/mailicon.png";
import Logo from "../../assets/logo.svg";
import { Avatar } from '@mui/material';
import LeftSidContainer from '../login/leftSidePart';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="/">
                {GLOBAL_CONSTANTS.MAINTITLE}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function ForgotPassword() {
    const [approvel, setApprovel] = useState(false)
    const [approvelMsg, setApprovelMsg] = useState('')
    const [loginInfo, setLoginInfo] = useState({
        email: '',
    });
    const [error, setError] = useState<any>({
        email: '',
    })
    const [errorMsg, setErrorMsg] = useState({
        email: '',
    })

    const [ForgotPasswordApiCall] = useForgotPasswordMutation();
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        var payload = {
            email: loginInfo.email,
        }
        if (!error.email && nullUndefinedEmptyCheck(loginInfo.email)) {
            ForgotPasswordApiCall(payload)
                .unwrap()
                .then((response) => {
                    toast.success(response?.message, TOASTER_CONFIGS);
                    setApprovel(true);
                    setApprovelMsg(response?.message)
                    // navigate(ROUTES.LOGIN);
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        } else {
            kychandleChange('email', '')
        }
    };

    //handle input changes 
    const kychandleChange = (name: any, value: any) => {
        var results = validateInput(name, value);
        if (results) {
            setError({ ...error, ...results.error });
            setErrorMsg({ ...errorMsg, ...results.errorMsg });
        }
        setLoginInfo({ ...loginInfo, [name]: value });
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid container style={{ height: '100vh' }}>
                {/* Left side with background image */}
                <LeftSidContainer />

                {/* Right side with login form */}
                <Grid item xs={12} md={6} sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Container component="main" maxWidth="xs">
                        <CssBaseline />
                        <Box
                            sx={{
                                marginTop: 8,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >

                            {approvel ? (
                                <>

                                    <img src={approval_icon} alt="" />
                                    <Typography component="h1" variant="h5" sx={{ marginTop: 8, }}>
                                        {approvelMsg}
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                        <img src={Logo} width={50} height={50} alt='logo' />
                                    </Avatar>
                                    <Typography component="h1" variant="h5">
                                        Forgot Your Password?
                                    </Typography>
                                    <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                                        <TextField
                                            name='email'
                                            onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                            onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                            onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                            label='email'
                                            variant='outlined'
                                            helperText={errorMsg.email}
                                            value={loginInfo.email}
                                            error={error?.email}
                                            margin="normal"
                                            type='text'
                                            fullWidth
                                            inputProps={{ inputmode: 'email' }}
                                            InputProps={error.emailId && (errorMsg.email || loginInfo.email) === '' ? {} : {
                                                endAdornment: <CheckCircleOutlinedIcon />
                                            }}
                                        />
                                        <Button
                                            type="submit"
                                            fullWidth
                                            variant="contained"
                                            sx={{ mt: 3, mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                        >
                                            Submit
                                        </Button>
                                        <Grid container>
                                            <Grid item xs>
                                                <Link href={ROUTES.LOGIN} variant="body2">
                                                    Back to login?
                                                </Link>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </>
                            )}

                        </Box>
                        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
                    </Container>
                </Grid>
            </Grid>
        </ThemeProvider >
    );
}